const permission = {
  matrix: 'matrix',
  schedule: 'schedule',
  timer: 'timer',
  messages: 'messages',
  proposals: 'proposals',
  clients: 'clients',
  invoices: 'invoices',
  items: 'items',
  properties: 'properties',
  installers: 'installers',
  settings: 'settings',
  reminders: 'reminders',
  logs: 'logs',
  archive: 'proposals', // Archive uses proposals permission
  installations: 'proposals', // Installations uses proposals permission
  waitList: 'wait_list',
  payments: 'payments', // Square payment requests + receivables dashboard
};

export default permission;
